import { GXLLogo } from "@/components/ui/GXLLogo";
import { PaperclipLogoMark } from "@/components/ui/PaperclipLogoMark";
import { cn } from "@/utils/cn";
import { ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

type LogoLockupProps = {
  className?: string;
  /** When true (default), show the paperclip icon on mobile and wordmark on md+. */
  compactPaperclip?: boolean;
};

export const LogoLockup = ({
  className,
  compactPaperclip = true,
}: LogoLockupProps) => {
  return (
    <div
      className={cn(
        "flex min-w-0 items-center gap-2 md:gap-3 text-zinc-900 font-semibold",
        className,
      )}
    >
      <a
        href="https://gxl.ai"
        target="_blank"
        rel="noopener noreferrer"
        className="group/gxl relative inline-block shrink-0"
        aria-label="GXL (opens in new tab)"
      >
        <span className="md:hidden">
          <GXLLogo height={12} />
        </span>
        <span className="hidden md:block">
          <GXLLogo height={18} />
        </span>
        <ExternalLink
          className="hidden md:block pointer-events-none absolute -top-2 -right-2 h-2.5 w-2.5 text-zinc-400 opacity-0 transition-opacity group-hover/gxl:opacity-100 group-focus-visible/gxl:opacity-100 md:h-3 md:w-3"
          aria-hidden
        />
      </a>
      <span className="text-zinc-300" aria-hidden>
        |
      </span>
      <Link to="/" aria-label="Paperclip" className="font-logo flex items-center">
        {compactPaperclip ? (
          <>
            <PaperclipLogoMark size="sm" className="md:hidden" />
            <span className="hidden md:inline pt-2">Paperclip</span>
          </>
        ) : (
          <span>Paperclip</span>
        )}
      </Link>
    </div>
  );
};
